import { useCallback, useEffect, useState } from "react";
import { getMarketingDoc, saveMarketingDoc } from "../api/services/marketingService";

/** Loads/saves one per-workspace marketing document (greeting, cta, action, rules, conversions, integrations). */
export default function useMarketingDoc(section) {
  const [state, setState] = useState({ status: "loading", doc: null, error: "" });

  useEffect(() => {
    let active = true;
    getMarketingDoc(section)
      .then((doc) => { if (active) setState({ status: "ready", doc, error: "" }); })
      .catch((error) => { if (active) setState({ status: "error", doc: null, error: error.message || "Unable to load settings." }); });
    return () => { active = false; };
  }, [section]);

  const save = useCallback(async (doc) => {
    const saved = await saveMarketingDoc(section, doc);
    setState((current) => ({ ...current, doc: saved }));
    return saved;
  }, [section]);

  return { ...state, save };
}
